import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
  standalone: false,
})
export class PhonePipe implements PipeTransform {
  public transform(value: string): string {
    if (value) {
      const regx: RegExp = /^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/g;
      const regxSpace: RegExp = /\s/g;
      value = value.replace(regxSpace, '');

      if (regx.test(value)) {
        return value.replace(regx, '$1 $2 $3 $4 $5');
      }
    }
    return value;
  }
}
